import { buildPath } from "@rentspree/path"
import { BASE_NAME, MAIN_URL } from "env"
import { ROUTE } from "containers/router/constants"

export const getErrorUrl = queryString =>
  buildPath(MAIN_URL + BASE_NAME + ROUTE.ERROR, null, queryString)
